import React from 'react'
import {ServerConfig} from 'config'

import NonPaginatedList from '../../components/EntryListAndEdit/NonPaginatedList'

const Sites = () => {
  const non_editable_fields = [
    ["id", "id", ""],
  ];

  const editable_fields = [
    ["name", "Name"],
    ["street", "Street"],
    ["zip", "ZipCode"],
    ["city", "City"],
    ["state", "State"],
    ["phone_number", "Phone Number"],
	  ['hours', 'Hours', "hours"],
  ];

  return (
    <>
      <NonPaginatedList
        list_get_url={`${ServerConfig.SERVER_URL}/tenant/tenant_sites`}
        detail_get_url={`${ServerConfig.SERVER_URL}/tenant/tenant_sites/`}
        detail_put_url={`${ServerConfig.SERVER_URL}/tenant/tenant_sites/`}

        column_names={["id", "name"]}
        header_names={["id", "name"]}

        optional_column_names={["street", "zip", "city", "state", "services"]}
        optional_header_names={["Street", "Zip", "City", "State", "Services"]}

        filter_inputs={[]}

        editable_fields={editable_fields}
        non_editable_fields={non_editable_fields}
        //show_machine_stats={true}
      />
    </>
  )
}

export default Sites
